import { Flex } from "@/atoms"
import { useIssueAndProjectDescription } from "@/organisms/Drawers/applications/triage/useTriage"
import { useIsEvpDemo } from "../../hooks/useIsEvpDemo"
import { MaliciousPackageAlert } from "../MaliciousPackageAlert"
import { SastIssueDescriptionKai } from "../SastIssueDescriptionKai"
import { ActionsMetaBar } from "../TakenActions"

import styles from "./ExtraTriageDrawer.module.scss"

export const ExtraTriageDrawer = (props: {
  record?: { id: string }
  drawerId?: string
}) => {
  const issueId = props.record?.id
  const [{ response }, _, isAllLoaded] = useIssueAndProjectDescription(issueId)
  const issue = response?.data?.[0]

  const isDemo = useIsEvpDemo()

  if (isAllLoaded || !issue) return null

  return (
    <Flex vertical>
      {!isDemo && (
        <>
          <SastIssueDescriptionKai issue={issue} />
          <MaliciousPackageAlert issue={issue} className={styles.alert} />
        </>
      )}
      {isDemo && <ActionsMetaBar issueId={issueId} drawerId={props.drawerId} />}
    </Flex>
  )
}
